

























































































































import Vue from 'vue';

export default Vue.extend({
  name: 'Header',
  components: {

  },
  props: ['showDescription'],
  computed: {
    isLoggedIn() {
      return this.$store.getters.loggedIn;
    },
  },
});
